module.exports = __webpack_public_path__ + "static/media/shape1_7.5894085a.obj";